import { useState, useEffect, useMemo } from "react";

import { routePaths, storage } from "../consts";
import { historyService } from "../services";

const excludedPaths = [routePaths.LOGIN];
const includeFullPaths = [routePaths.NOTIFICATIONS, routePaths.FLEET_MANAGEMENT];

const useNavigationDetector = (preventNavigationRoutes = []) => {
  const [pathname, setPathname] = useState(window.location.pathname);

  const preventNavigation = useMemo(() => {
    return preventNavigationRoutes.some((route) => window.location.pathname.includes(route));
  }, [preventNavigationRoutes, window.location.pathname]);

  const history = historyService.getHistory();

  useEffect(() => {
    const unlisten = history.listen((location) => {
      setPathname(location.pathname);
    });

    const unblock = history.block((location) => {
      const basePath = `/${location.pathname.split("/")[1]}`;

      return !(preventNavigation && pathname && !excludedPaths.includes(basePath));
    });

    return () => {
      unlisten();
      unblock();
    };
  }, [history, pathname, preventNavigation, excludedPaths]);

  useEffect(() => {
    if (pathname) {
      const basePath = `/${pathname.split("/")[1]}`;

      if (!excludedPaths.includes(basePath)) {
        localStorage.setItem(
          storage.PATHNAME,
          includeFullPaths.includes(basePath) ? pathname : basePath
        );
      }

      setPathname(null);
    }
  }, [pathname, excludedPaths]);

  useEffect(() => {
    if (preventNavigation) {
      window.addEventListener("beforeunload", beforeUnloadHandler);
    } else {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    }

    return () => {
      window.removeEventListener("beforeunload", beforeUnloadHandler);
    };
  }, [preventNavigation]);

  const beforeUnloadHandler = (event) => {
    event.preventDefault();
  };

  return null;
};

export default useNavigationDetector;
